import React from 'react';
import FAQ from './FAQ';
import './faq.css';

function App() {
  return (
    <div className="App">
      <FAQ />
    </div>
  );
}

export default App;
